import React, { useEffect, useState } from "react";
import DateSelector from "../../../components/shared/fields/DateSelector";
import GridCard from "../../../components/shared/gridCard/GridCard";
import KgEntered from "../../../images/material_kg.svg";
import TotalCase from "../../../images/totalCase.svg";
import TotalOrangeCase from "../../../images/total_orange.svg";
import TabsComponent from "../../../components/shared/tabs/TabsComponent";
import StaffAttendenceTab from "./StaffAttendenceTab";
import { useGetStaffAttendanceSummaryQuery } from "../staffAttendanceApi";
import { useNavigate, useLocation } from "react-router-dom";
import { useGetWorkingAreasQuery } from "../../../app/globalApi";
import useTranslator from "../../../hooks/useTranslator";
import { formatDateAndTime, getCurrentDate } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";
const currentDate = getCurrentDate("YYYY-MM-DD");
const allowedTabs = [
  "Manager",
  "Nursing",
  "Safety",
  "General Cleaning",
  "Other",
];

const StaffAttendence = () => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const location = useLocation();
  const [date, setDate] = useState(currentDate);
  const [activeKey, setActiveKey] = useState(null);
  const [tabsData, setTabsData] = useState([]);
  const { data: workingAreas, isLoading } = useGetWorkingAreasQuery();
  const { data: staffAttendanceSummary, refetch } =
    useGetStaffAttendanceSummaryQuery(
      {
        date: date,
        working_area_id: activeKey,
      },
      { skip: !activeKey }
    );

  useEffect(() => {
    if (workingAreas && workingAreas.data) {
      const tabs = [];
      workingAreas.data.forEach((workingArea) => {
        if (allowedTabs.includes(workingArea.name)) {
          tabs.push({
            label: workingArea.name,
            eventKey: workingArea.id,
            content: <></>,
          });
        }
      });
      setTabsData(tabs);
    }
  }, [workingAreas]);

  useEffect(() => {
    if (tabsData.length > 0) {
      setActiveKey(tabsData[0].eventKey);
    }
  }, [tabsData]);

  useEffect(() => {
    if (activeKey) {
      refetch();
      addQueryParam("activeTab", activeKey);
    }
  }, [date, activeKey, refetch]);

  const addQueryParam = (key, value) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set(key, value);
    navigate(`${location.pathname}?${searchParams.toString()}`);
  };

  return (
    <div>
      {isLoading && (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}
      {!isLoading && activeKey && (
        <>
          <div className="overview cmn_card mb-3">
            <div className="overview_header d-flex gap-2 align-items-center">
              <h6 className="mb-0 flex-grow-1">
                {_t("staff_summary", "Staff Summary")}
              </h6>

              <DateSelector setDate={setDate} />
            </div>
            <ul className="m-0 grid_card_wrapper">
              <GridCard
                title={_t("total_staff", "Total Staff")}
                value={staffAttendanceSummary?.data?.total_employee}
                icon={KgEntered}
                day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date ,PROJECT_DATE_FORMAT)}
              />
              <GridCard
                title={_t("present_staff", "Present Staff")}
                value={staffAttendanceSummary?.data?.present_employee}
                icon={TotalCase}
                day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date ,PROJECT_DATE_FORMAT)}
              />
              <GridCard
                title={_t("absent_staff", "Absent Staff")}
                value={staffAttendanceSummary?.data?.absent_employee}
                icon={TotalOrangeCase}
                day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date ,PROJECT_DATE_FORMAT)}
              />
            </ul>
          </div>
          <div className="tabs_outer">
            <TabsComponent
              tabs={tabsData}
              defaultKey={activeKey}
              layout="horizontal"
              setActiveKey={setActiveKey}
            />
            <div className="tabs_content">
              <StaffAttendenceTab tab={activeKey} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default StaffAttendence;
